export class GalleryImage {
  id?: number;
  imageUrl?: string;
  type?: string;
}
